// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-container {
  display: flex;
  flex-direction: column;
  color: white;
  font-family: monospace;
  margin-right: 3px;
  overflow: hidden;
  flex: 1 1 auto;
}

.sequence .sequence-row {
  display: flex;
  border-left: 2px solid rgba(0, 0, 0, 0);
  padding: 2px;
  overflow-x: hidden;
  justify-content: center;
}

.sequence .sequence-row.current-pattern {
  border: 2px solid #444;
  border-radius: 3px;
}

.sequence .sequence-index,
.sequence .sequence-pattern {
  display: table-cell;
  text-align: center;
  min-width: 24px;
}

.sequence .sequence-index {
  min-width: 24px;
  margin-right: 5px;
}

.sequence .sequence-pattern {
  background-color: #014D6E;
}

.sequence .sequence-index div,
.sequence .sequence-pattern div {
  padding: 0 3px;
  border: 1px solid gray;
  border-radius: 3px;
}

.sequence .sequence-pattern div {
  border-color: white;
}

.sequence .sequence-row.current-pattern .sequence-index div {
  background: #090;
}

.sequence .sequence-top-padding,
.sequence .sequence-bottom-padding {
  flex-shrink: 0;
}

.sequence-controls .control-panel {
  justify-content: center;
}

.sequence-controls .control-panel button {
  width: 22px;
  height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/components/sequence_editor/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".list-container {\n  display: flex;\n  flex-direction: column;\n  color: white;\n  font-family: monospace;\n  margin-right: 3px;\n  overflow: hidden;\n  flex: 1 1 auto;\n}\n\n.sequence .sequence-row {\n  display: flex;\n  border-left: 2px solid rgba(0, 0, 0, 0);\n  padding: 2px;\n  overflow-x: hidden;\n  justify-content: center;\n}\n\n.sequence .sequence-row.current-pattern {\n  border: 2px solid #444;\n  border-radius: 3px;\n}\n\n.sequence .sequence-index,\n.sequence .sequence-pattern {\n  display: table-cell;\n  text-align: center;\n  min-width: 24px;\n}\n\n.sequence .sequence-index {\n  min-width: 24px;\n  margin-right: 5px;\n}\n\n.sequence .sequence-pattern {\n  background-color: #014D6E;\n}\n\n.sequence .sequence-index div,\n.sequence .sequence-pattern div {\n  padding: 0 3px;\n  border: 1px solid gray;\n  border-radius: 3px;\n}\n\n.sequence .sequence-pattern div {\n  border-color: white;\n}\n\n.sequence .sequence-row.current-pattern .sequence-index div {\n  background: #090;\n}\n\n.sequence .sequence-top-padding,\n.sequence .sequence-bottom-padding {\n  flex-shrink: 0;\n}\n\n.sequence-controls .control-panel {\n  justify-content: center;\n}\n\n.sequence-controls .control-panel button {\n  width: 22px;\n  height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
